import { Http } from '@pirates/not-morty-biz';
import { Company } from './company.model';

export class CompanyService {
  public async update(id: number, company: Partial<Company>) {
    return Http.patch<Company>(`/api/b2b/bo-api/v1/customer/companies/${id}`, company);
  }
}

export const companyService = new CompanyService();
